export default "__VITE_ASSET__55873a50__"